import { ThunkAction } from 'redux-thunk'

import { getHomepageDataFromCloudfront } from '../../../common/utils/getDataFromS3'
import { logError } from '../../utils/errors'

import { ISearchResults } from '../../../typings/searchResults'
import { IRootState } from '../../reducers'

export enum TypeKeys {
  GET_NEWEST_ITEMS_BY_CATEGORY_PENDING = 'GET_NEWEST_ITEMS_BY_CATEGORY_PENDING',
  GET_NEWEST_ITEMS_BY_CATEGORY_SUCCESS = 'GET_NEWEST_ITEMS_BY_CATEGORY_SUCCESS',
  GET_NEWEST_ITEMS_BY_CATEGORY_FAIL = 'GET_NEWEST_ITEMS_BY_CATEGORY_FAIL'
}

interface IPendingPayload {
  readonly category: string
}

interface ISuccessPayload {
  readonly category: string
  readonly searchResults: Readonly<ISearchResults>
}

export interface IGetNewestItemsByCategoryPendingAction {
  readonly type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_PENDING
  readonly payload: IPendingPayload
}

export interface IGetNewestItemsByCategorySuccessAction {
  readonly type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_SUCCESS
  readonly payload: ISuccessPayload
}

export interface IGetNewestItemsByCategoryFailAction {
  readonly type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_FAIL
}

export type ActionTypes =
  | IGetNewestItemsByCategoryPendingAction
  | IGetNewestItemsByCategorySuccessAction
  | IGetNewestItemsByCategoryFailAction

export const fetchNewestItemsByCategory = (
  category: string
): ThunkAction<
  Promise<
    IGetNewestItemsByCategorySuccessAction | IGetNewestItemsByCategoryFailAction
  >,
  IRootState,
  any
> => {
  return (dispatch, getState) => {
    const { currentSite } = getState().common

    dispatch({
      payload: { category },
      type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_PENDING
    })
    return getHomepageDataFromCloudfront(
      currentSite,
      'newest-items',
      category === 'all' ? 'index' : category
    )
      .then(response => {
        const successAction: IGetNewestItemsByCategorySuccessAction = {
          payload: { searchResults: response.data, category },
          type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_SUCCESS
        }
        return dispatch(successAction)
      })
      .catch(err => Promise.reject(logError(err)))
      .catch(() => {
        const failAction: IGetNewestItemsByCategoryFailAction = {
          type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_FAIL
        }
        return dispatch(failAction)
      })
  }
}
